import React from 'react';
import { Box, Typography, Avatar, AppBar, Toolbar, IconButton, Switch, FormControlLabel } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const ChatHeader = ({
    isMobile,
    contactActive,
    setOpenDrawer,
    userSystem,
    userLoggedIn,
    executiveMode,
    setExecutiveMode
}) => {
    return (
        <AppBar position="sticky" sx={{ backgroundColor: '#111b21' }}>
            <Toolbar>

                {(isMobile && userLoggedIn) && (
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={() => setOpenDrawer(true)}
                        sx={{ marginRight: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}

                {/* IZQUIERDA: Avatar + Nombre */}
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                    <Avatar sx={{ width: 40, height: 40, marginRight: 2 }} />

                    {contactActive?.nameContact ? (
                        <Typography variant="h6" sx={{ color: '#fff' }}>
                            {contactActive.nameContact}
                        </Typography>
                    ) : (
                        <Typography variant="h6" sx={{ color: '#fff' }}>
                            {userSystem ? "Seleccionar un chat" : "Iniciar sesión"}
                        </Typography>
                    )}
                </Box>

                {/*contactActive && (
                    <FormControlLabel
                        control={
                            <Switch
                                checked={executiveMode}
                                onChange={(e) => setExecutiveMode(e.target.checked)}
                                color="success"
                            />
                        }
                        label={executiveMode ? "Ejecutivo" : "IA"}
                        labelPlacement="start"
                        sx={{ color: '#fff' }}
                    />
                )*/}

            </Toolbar>
        </AppBar>
    );
};

export default ChatHeader;
